import { render, staticRenderFns } from "./DiscoveryExperts.vue?vue&type=template&id=97005970&scoped=true"
import script from "./DiscoveryExperts.vue?vue&type=script&lang=js"
export * from "./DiscoveryExperts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97005970",
  null
  
)

export default component.exports